'use client';

import Link from 'next/link';

import type { ContactCardProps } from '@eliadmin/core/src/components/header/mobile-sidebar';

import { ButtonIcon } from '@eliadmin/core/src/components/ui/button-icon';
import { PiArrowCircleRightFill } from 'react-icons/pi';

export function ContactCard({ contact }: { contact: ContactCardProps }) {
  return (
    <Link
      key={contact.label}
      prefetch={false}
      target="_blank"
      href={contact?.href}
      className="flex w-full items-center justify-between gap-4 rounded-[16px] bg-[#F4F7FB] p-4"
    >
      <div className="flex max-h-12 min-h-12 min-w-12 max-w-12 items-center justify-center rounded-[12px] bg-white">
        <ButtonIcon
          alt={contact.label}
          url={contact.icon}
          className="max-h-6 min-h-6 min-w-6 max-w-6"
        />
      </div>
      <div className="flex w-full flex-col items-start justify-start gap-1">
        <p className="text-sm font-semibold uppercase text-[#646B96]">{contact.label}</p>
        <strong className="text-base font-semibold text-secondary">{contact.value}</strong>
        <p className="text-sm font-normal text-[#646B96]">{contact.description}</p>
      </div>
      <PiArrowCircleRightFill size={20} className="max-h-5 min-h-5 min-w-5 max-w-5 text-primary" />
    </Link>
  );
}
